import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";
import { useNavigate } from "@tanstack/react-router";

import { communitiesPaths } from "@/react/helpers/routerPathHelpers";

export const FROM_GETTING_STARTED = "getting-started" as const;

export const useNavigateAfterInviteFlow = (from: string | undefined) => {
  const navigate = useNavigate();

  return () => {
    if (from === FROM_GETTING_STARTED) {
      void navigate({ href: communitiesPaths.onboarding() });
    } else if (from?.startsWith("/") && !from.startsWith("//")) {
      void navigate({ href: from });
    } else {
      void navigate({ to: settingsNavPathV3.members.manage });
    }
  };
};
